export const HIDDEN_FACETS = [
	'hat_bill',
	'hat_crown',
	'hat_structure',
	'facet_sub_dept'
];

export const CATEGORY_FACETS = {
	departments: [
		'league',
		'real_team',
		'facet_department'
	],
	teams: [
		'league',
		'real_team',
		'facet_department',
		'facet_sub_dept'
	]
};

export const DEPARTMENT_FACETS = {
	Hats: [
		'hat_bill',
		'hat_crown',
		'hat_structure'
	]
};
